import React from "react";
import ReactDOM from "react-dom";
import LifeInsuranceAdvancedConfigModal from "./index";

export default async function renderLifeInsuranceAdvancedConfigModal({
  target = "modal-container",
  ...rest
}) {
  const domTarget = document.getElementById(target);
  if (domTarget) {
    ReactDOM.render(<LifeInsuranceAdvancedConfigModal {...rest} />, domTarget);
  }
}
